module.exports = __webpack_public_path__ + "img/left-arrow.307c8ca7.svg";